import { useQuery } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import EudrDashboardService from 'src/modules/3rd-party-management/apis/admin/EudrDashboardService';

export const EUDR_SUBMISSION_TO_TRACE_QUERY_KEY = '3rd-party-management-fetch-eudr-submission-to-trace';

const useSubmissionToTrace = ({
    t,
}) => {
    const query = useQuery({
        queryKey: [EUDR_SUBMISSION_TO_TRACE_QUERY_KEY],
        queryFn: async () => {
            const service = EudrDashboardService.getInstance();

            return await service.fetchSubmissionToTrace();
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        onError: (error) => {
            if (process.env.NODE_ENV === 'development') console.error(error);

            toast(t('An error occurred while fetching EUDR submission to TRACE data.'), {
                type: 'error',
            });
        },
    });

    const data = query.data;

    if (!data) {
        return {
            ...query,
            segments: null,
            verifiedPercentage: 0,
            missingDdsCount: 0,
        };
    }

    const segments = (data.chart || []).map((item) => ({
        key: item.label,
        label: t(item.label),
        value: Number(item.value) || 0,
        color: item.color,
    }));

    const missingDdsCount = segments.find((segment) => segment.key === 'Missing DDS')?.value || 0;

    return {
        ...query,
        segments,
        verifiedPercentage: Number(data.knob?.percentage) || 0,
        missingDdsCount,
    };
};

export default useSubmissionToTrace;
